import { render } from "./ListCutiBersamaView.vue?vue&type=template&id=628f44d4"
import script from "./ListCutiBersamaView.vue?vue&type=script&lang=js"
export * from "./ListCutiBersamaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__